import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { errorInterceptor } from '@core/http/error.interceptor';
import { authInterceptor } from '@core/http/auth.interceptor';
import { facilityIdInterceptor } from '@core/http/facility-id.interceptor';
import { loaderInterceptor } from '@core/http/loader.interceptor';
import { refreshInterceptor } from '@core/http/refresh.interceptor';

/**
 * Single entry-point for app-wide singleton providers.
 * Add new global providers here so `app.config.ts` stays concise.
 *
 * Interceptor order matters for failed responses. Angular builds
 * `facilityId(auth(error(refresh(loader(backend)))))` from the array below.
 * The refresh interceptor sits inside the error interceptor so a recovered 401
 * does not trigger a global alert. The loader's inner `catchError` can `hide()`
 * before the outer error `catchError` shows an alert.
 */
export function provideCore(): EnvironmentProviders {
	return makeEnvironmentProviders([
		provideHttpClient(
			withInterceptors([
				facilityIdInterceptor,
				authInterceptor,
				errorInterceptor,
				refreshInterceptor,
				loaderInterceptor,
			]),
		),
	]);
}
